import styled from "styled-components";
import NumberFormat from "react-number-format";

import { colors } from "../../styles";
import { useState } from "react";

const STYLES = {
  display: "inline-block",
  width: "100%",
  backgroundColor: colors.white,
  border: `solid 2px ${colors.lightGray}`,
  borderRadius: "5px",
  padding: "15px",
};

const Root = styled.input({
  ...STYLES,
  borderColor: (props) => (props.error ? colors.red : colors.lightGray),
});

const Subtext = styled.div`
  text-align: right;
  font-size: 0.8em;
  color: ${colors.darkGray};
`;

const ErrorMessage = styled.div`
  color: ${colors.red};
  text-align: right;
`;

const InputText = ({ subtext, error, ...props }) => {
  return (
    <div style={{ width: "100%" }}>
      <Root {...props} error={error} />
      {!error && subtext && <Subtext>{subtext}</Subtext>}
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </div>
  );
};

export default InputText;

export const InputNumberFormat = ({ subtext, error, ...props }) => {
  const [showMask, setShowMask] = useState(false);

  return (
    <>
      <NumberFormat
        {...props}
        style={STYLES}
        allowEmptyFormatting={showMask}
        onFocus={() => {
          setShowMask(true);
        }}
        onBlur={() => {
          setShowMask(false);
        }}
      />
      {!error && subtext && <Subtext>{subtext}</Subtext>}
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </>
  );
};
